
import { Company } from "./company";
import FirestoreModel from "../FirestoreModel"
import { DateTime } from "luxon";
import { Bay } from "./bay";
import { Customer } from "./customer";
import { nowLiteral } from "./periods";
import { Slot } from "./slot";


export class Location extends FirestoreModel<Location>() {

  name: string;
  tz: string;
  address: string;
  openingMinute: number;
  closingMinute: number;
  primeTimeMorningEnd: number;
  primeTimeAfternoonStart: number;
  primeTimeAfternoonEnd: number;
  primeTimeEveningStart: number;

  static collectionPath = (companyId: string) => [...Company.refPath(companyId), "locations"];
  static refPath = (companyId: string, locationId: string) => [...this.collectionPath(companyId), locationId];
  static collection(companyId: string) {
    return this.pathToCollection(this.collectionPath(companyId));
  }
  static ref(companyId: string, locationId: string) {
    return super.pathToRef(this.refPath(companyId, locationId));
  }


  constructor(snapshot: any) {
    super(snapshot);
    const data = snapshot.data();
    this.name = data.name;
    this.tz = data.tz;
    this.address = data.address;
    this.openingMinute = data.openingMinute;
    this.closingMinute = data.closingMinute;
    this.primeTimeMorningEnd = data.primeTimeMorningEnd;
    this.primeTimeAfternoonStart = data.primeTimeAfternoonStart;
    this.primeTimeAfternoonEnd = data.primeTimeAfternoonEnd;
    this.primeTimeEveningStart = data.primeTimeEveningStart;
  }

  isOpen(dt: DateTime) {
    const m = (dt.hour * 60) + dt.minute;
    return m >= this.openingMinute && m < this.closingMinute;
  }

  inPrimeTime(dt: DateTime) {
    if (dt.weekday === 6 || dt.weekday === 7) return true;
    if (dt.hour < this.primeTimeMorningEnd) return true;
    if (dt.hour >= this.primeTimeAfternoonStart && dt.hour < this.primeTimeAfternoonEnd) return true;
    if (dt.hour >= this.primeTimeEveningStart) return true;
    return false;
  }

  timeAvailable(startTime: DateTime, bays: Bay[], slotByBay: { [bayId: string]: Slot }, customer: Customer) {
    let best = 0;
    for(const bay of bays) {
      for(let i = 30; i <= 120; i += 30) {
        const time = startTime.plus({minutes: i - 30});
        if(slotByBay[bay.id]?.isTimeTaken(time)) break;
        if(time < nowLiteral(this.tz)) break;
        if(!this.isOpen(time)) break;
        if(!customer.primeTime && this.inPrimeTime(time)) break;
        if(i >= best) best = i;
      }
    }
    return best;
  }

  baysAvailable(time: DateTime, bays: Bay[], slotByBay: { [bayId: string]: Slot }) {
    let bayCount = 0;
    for(const bay of bays) {
      if(!slotByBay[bay.id]?.isTimeTaken(time)) bayCount += 1;
    }
    return bayCount;
  }

  bayForTime(time: DateTime, duration: number, bays: Bay[], slotByBay: { [bayId: string]: Slot }) {

    const checkBay = (bay: Bay) => {
      for(let i = 0; i < duration; i += 30) {
        if(slotByBay[bay.id]?.isTimeTaken(time.plus({minutes: i}))) return false;
      }
      return true;
    }

    for(const bay of bays) {
      if(checkBay(bay)) return bay;
    }

    return null;
  }
}